import { c as _c } from "react/compiler-runtime";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import CreateWaveApprovalThreshold from "./CreateWaveApprovalThreshold";
import CreateWaveApprovalThresholdTime from "./CreateWaveApprovalThresholdTime";
export default function CreateWaveApproval(t0) {
  const $ = _c(19);
  const {
    threshold,
    thresholdTimeMs,
    errors,
    setThreshold,
    setThresholdTimeMs
  } = t0;
  let t1;
  if ($[0] !== errors) {
    t1 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.APPROVAL_THRESHOLD_REQUIRED);
    $[0] = errors;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const thresholdError = t1;
  let t2;
  if ($[2] !== errors) {
    t2 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.APPROVAL_THRESHOLD_TIME_REQUIRED);
    $[2] = errors;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const thresholdTimeError = t2;
  let t3;
  if ($[4] !== errors) {
    t3 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.APPROVAL_THRESHOLD_TIME_MUST_BE_SMALLER_THAN_WAVE_DURATION);
    $[4] = errors;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const thresholdDurationError = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="tw-mb-0 tw-text-lg  sm:tw-text-xl tw-font-semibold tw-text-iron-50">Approval</p>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== setThreshold || $[8] !== threshold || $[9] !== thresholdError) {
    t5 = <CreateWaveApprovalThreshold threshold={threshold} error={thresholdError} setThreshold={setThreshold} />;
    $[7] = setThreshold;
    $[8] = threshold;
    $[9] = thresholdError;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== setThresholdTimeMs || $[12] !== thresholdDurationError || $[13] !== thresholdTimeError || $[14] !== thresholdTimeMs) {
    t6 = <CreateWaveApprovalThresholdTime thresholdTimeMs={thresholdTimeMs} thresholdTimeError={thresholdTimeError} thresholdDurationError={thresholdDurationError} setThresholdTimeMs={setThresholdTimeMs} />;
    $[11] = setThresholdTimeMs;
    $[12] = thresholdDurationError;
    $[13] = thresholdTimeError;
    $[14] = thresholdTimeMs;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div>{t4}<div className="tw-mt-2">{t5}{t6}</div></div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}